module.exports = __webpack_public_path__ + "static/media/celu1.bf76d805.png";